module.exports = __webpack_public_path__ + "static/media/kango-logo.a07b5d55.svg";